import Blank from './Blank'

export default Blank